import axios from "axios";
import axiosRetry from "axios-retry";
import { authenticationHeader } from "./authenticationHeader";
import { deviceConstants, EMPTY_STRING } from "../constants";

axiosRetry(axios, {
  retries: window?.config?.FAILED_API_REQUEST_RETRY_COUNT || 3,
  retryDelay: (retryCount) =>
    window?.config?.FAILED_API_REQUEST_RETRY_DELAY || 5000,
  retryCondition: (error, test) => {
    // Only retry on network errors (1. no internet 2. connection refused - server is not running)
    let res = false;
    // don't retry in case of payrillium requests does not matter the error code
    if (
      String(error.config.url)
        .toLowerCase()
        .includes(deviceConstants.PAYMENT_DEVICE_TYPES.PAYRILLIUM.toLowerCase())
    ) {
      res = false;
    } else if (
      error.code === "ECONNABORTED" ||
      error.message === "Network Error"
    ) {
      res = true;
    }
    // Axios sets error.code to 'ERR_NETWORK' for refused connections (server is not running)
    else if (error.code === "ERR_NETWORK") {
      res = true;
    }
    return res;
  },
});

//-------Build Url for server api call
const buildURL = (url, isAddBaseUrl = true) => {
  let BaseUrl = EMPTY_STRING;
  if (isAddBaseUrl) {
    BaseUrl = process.env.REACT_APP_BASE_URL;
  }
  return BaseUrl + url;
};

//-------Build headers for the server api call
const buildHeaders = (authorization, extraHeaders = {}) => {
  let headers = {
    Accept: "application/json",
  };

  if (authorization === true) {
    headers = { ...headers, ...authenticationHeader() };
  }

  return { ...headers, ...extraHeaders };
};

//-------Get request to the server
const getRequest = (url, authorization = true, dataObject = false) => {
  const completeUrl = buildURL(url);
  let requestOptions = {};
  if (dataObject) {
    requestOptions = {
      method: "GET",
      headers: buildHeaders(authorization),
      params: dataObject,
    };
  } else {
    requestOptions = {
      method: "GET",
      headers: buildHeaders(authorization),
    };
  }

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//-------Get request to the server
const getTcgRequest = (url, authorization = true, dataObject = false) => {
  const completeUrl = url;
  let requestOptions = {};
  if (dataObject) {
    requestOptions = {
      method: "GET",
      headers: buildHeaders(authorization),
      params: dataObject,
    };
  } else {
    requestOptions = {
      method: "GET",
      headers: buildHeaders(authorization),
    };
  }

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//-------Delete request to the server
const deleteRequest = (url, authorization = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "DELETE",
    headers: buildHeaders(authorization),
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//-------Delete request with data to the server
const deleteRequestWithData = (url, dataObject, authorization = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "DELETE",
    headers: buildHeaders(authorization),
    data: dataObject,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//-------Post request to the server
const postRequest = (
  url,
  dataObject,
  authorization = true,
  extraHeaders = {},
  isAddBaseUrl = true
) => {
  const completeUrl = buildURL(url, isAddBaseUrl);

  const requestOptions = {
    method: "POST",
    headers: buildHeaders(authorization, extraHeaders),
    data: dataObject,
  };
  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//-------Put request to the server
const putRequest = (url, dataObject, authorization = true) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "PUT",
    headers: buildHeaders(authorization),
    data: dataObject,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

//-------upload logo request
const uploadLogoRequest = (url, dataObject) => {
  const completeUrl = buildURL(url);

  const requestOptions = {
    method: "POST",
    headers: {
      ...authenticationHeader(),
      "Content-Type": "multipart/form-data",
    },
    data: dataObject,
  };

  axios.defaults.withCredentials = false;
  return axios(completeUrl, requestOptions);
};

const pricechartingApiRequest = (query) => {
  return axios.get(query);
};

const scryfallApiRequest = (query) => {
  return axios.get(query);
};

//-------get zpl code request request
const getZplCodeRequest = (url, dataObject) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: dataObject,
  };

  axios.defaults.withCredentials = false;
  return axios(url, requestOptions);
};

export {
  axios,
  getRequest,
  postRequest,
  putRequest,
  getTcgRequest,
  deleteRequest,
  uploadLogoRequest,
  deleteRequestWithData,
  pricechartingApiRequest,
  scryfallApiRequest,
  getZplCodeRequest,
};
